/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum ownershipTypes {
  PublicCorporation = "Public Corporation",
  PrivateCorporation = "Private Corporation",
  SECRegulatedCorporation = "SEC Regulated Corporation",
  Government = "Government",
  SoleProprietorship = "Sole Proprietorship",
  LLC = "LLC",
  Partnership = "Partnership",
  NonProfit = "NonProfit",
  FinancialInstitution = "Financial Institution",
  Trust = "Trust"
}
